import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable()
export class EmailValidationService {

  // Comprehensive email regex pattern
  private emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  /**
   * Custom email validator function that can be used in Angular forms
   * @param control - The form control to validate
   * @returns ValidationErrors | null
   */
  validateEmail(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }
    
    if (!this.emailRegex.test(String(control.value).toLowerCase())) {
      return { invalidEmail: true };
    }
    
    return null;
  }

  /**
   * Static method to validate email string directly
   * @param email - The email string to validate
   * @returns boolean
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    
    return this.emailRegex.test(String(email).toLowerCase());
  }

  /**
   * Get email validation error message
   * @returns string
   */
  getEmailErrorMessage(): string {
    return 'Please enter a valid email address';
  }
} 


// WEBPACK FOOTER //
// ./src/app/services/email-validation.service.ts